<template>
<div class="chapter">
<div class="inner_page">
<div id="Front">
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_1.jpg"/></p>
<p class="fig-caption"><i>Tiger</i>, <i>Lion</i> and, in the distance, <i>Princess Royal</i> in typical North Sea conditions.</p>
</div>
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_2.jpg"/></p>
<p class="fig-caption">A perfect broadside view of <i>Invincible</i> in 1910. Visually, dreadnought-era ships – both battleships and battlecruisers – introduced an entirely new element of asymmetry, which must have made the ships look at once novel and dramatic. Pre-dreadnought battleships and cruisers were marked by a balanced profile, with equally spaced funnels, a gun mounting fore and aft, and rows of ventilators all the same height; often the forward half of the ship was virtually a mirror image of the after part. Wing turrets made this impossible, and even when ships went over to an all-centreline main armament, they never regained the push-me-pull-you look of the previous generation.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?0cbc6344